import { render } from "./PDFJsView.vue?vue&type=template&id=06d93223&scoped=true"
import script from "./PDFJsView.vue?vue&type=script&lang=js"
export * from "./PDFJsView.vue?vue&type=script&lang=js"

import "./PDFJsView.vue?vue&type=style&index=0&id=06d93223&scoped=true&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d93223"]])

export default __exports__